import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { HttpClient, HttpHandler, HttpXhrBackend } from '@angular/common/http';

const injector: Injector = Injector.create({
  name: 'root',
  providers: [
    { provide: HttpClient, deps: [ HttpHandler ] },
    { provide: HttpHandler, useValue: new HttpXhrBackend({ build: () => new XMLHttpRequest() }) },
  ]
});

const http = injector.get(HttpClient);

if (environment.production) {
  enableProdMode();
}
http.get('assets/config.json').subscribe((r) => {
  Object.keys(r).forEach(k=>{
    environment[k] = r[k];
  });
  
  platformBrowserDynamic().bootstrapModule(AppModule);
});


